
  // This file was autogenerated by dynamically running set-environment.ts and using dotenv for managing API key secrecy
  export const environment = {
    production: false,
    apiUrl: 'https://dev.api.pyrocast.com',//https://beta.api.pyrocast.com',//' // https://dev.api.pyrocast.com
    appUrl: 'https://app.pyrocast.com',//'http://localhost:4200',//'https://app.pyrocast.com','https://app.pyrocast.com'
	skyDomain: 'app.skystreamevents.com',//'localhost',''app.skystreamevents.com'',
	tune2Domain: 'admin.tune2.app',//'localhost',''admin.tune2.app',
	tune2Domain2: 'web.tune2.app',//'localhost',''web.tune2.app',
	igniteDomain:  'dev.pyrocast.com',//'live.ignitefiringsystems.com',//'localhost',,//'localhost',//'localhost',
	COBRA_PORTAL_BASE_UI_URL: 'https://portal.cobrafiringsystems.com/login?originating_cobra_platform=PYROCAST&send_token_using=WINDOW_MESSAGE',//'https://portal.cobrafiringsystems.com/login?originating_cobra_platform=PYROCAST&send_token_using=WINDOW_MESSAGE',
	BASE_API_URL: 'https://beta.api.pyrocast.com',
	// BASE_API_URL: 'http://localhost:3065',
	stripePublicKey: 'pk_test_51T4Qlc8yAGUdbJl867hVJbsXEzvMCTQV7MqU8bWwI9NPh8OG5pUeXePvXYlrXhnTtzW0WBazvnZ7lnSpIHqdlLJI00qHAFJkbA',
	
	
	firebase: {
		apiKey: "AIzaSyDMmLcOgSXYa1fK4gBMbSpBpgtpZ-GUn9U",
		authDomain: "ignite-firing-systems-303723.firebaseapp.com",
		databaseURL: "https://ignite-firing-systems-303723-default-rtdb.firebaseio.com",
		projectId: "ignite-firing-systems-303723",
		storageBucket: "ignite-firing-systems-303723.appspot.com",
		messagingSenderId: "1086582487410",
		appId: "1:1086582487410:web:c5a374205decf80d2305eb",
		measurementId: "G-VBRLME905P",
		vapidKey: 'BAHctroTq3MqyYgmAAtqmk8T_pTtni39vgBKELxWzogpdM26y2z7PLxYtYOhlsjixCWkc8SuCoqYJGXgIlrdZZM'
	},
	showBrands: true
  };
